// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-widget .v-card-header{background:var(--widget-color)}.v-widget--active.v-widget,.v-widget:hover{border-bottom-color:var(--widget-color)}.v-widget-column .v-widget{height:100%;min-height:300px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
